import { formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import type { AdminDashboardQuery } from 'src/generated/graphql';
import { routes } from 'src/routes';

type Organization = NonNullable<
  AdminDashboardQuery['adminDashboard']
>['recentOrganizations'][0];

interface RecentOrgsListProps {
  organizations: Organization[];
}

export const RecentOrgsList = ({ organizations }: RecentOrgsListProps) => {
  if (organizations.length === 0) {
    return <p className="text-gray-500">No organizations found.</p>;
  }

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Organization
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Slug
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Registered By
            </th>
            <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Created
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {organizations.map((org) => (
            <tr key={org.id}>
              <td className="px-4 py-1.5 whitespace-nowrap text-sm font-medium">
                <Link
                  to={routes.org.getPath({ orgSlug: org.slug })}
                  className="text-blue-600 hover:text-blue-800 hover:underline"
                >
                  {org.name || '(unnamed)'}
                </Link>
              </td>
              <td className="px-4 py-1.5 whitespace-nowrap text-sm text-gray-500">
                {org.slug}
              </td>
              <td className="px-4 py-1.5 whitespace-nowrap text-sm text-gray-500">
                {org.registrant ? (
                  <span title={org.registrant.email}>
                    {org.registrant.name || org.registrant.email}
                  </span>
                ) : (
                  <span className="text-gray-400">Unknown</span>
                )}
              </td>
              <td className="px-4 py-1.5 whitespace-nowrap text-sm text-gray-500">
                {formatDistanceToNow(new Date(org.dateCreated), {
                  addSuffix: true,
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
